import type { ReactNode } from 'react';

export interface SectionProps {
  title?: string;
  children?: ReactNode;
}

export const Section = ({ title, children }: SectionProps) => (
  <div className="my-8">
    {title && <h5 className="bg-gray-100 px-4 py-6"> {title}</h5>}
    {children}
  </div>
);
